import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";
import { validateINMobile } from "../../../utils/Utils";

const MyMobile = ({
  title,
  name,
  register,
  watch,
  trigger,
  errors,
  setValue,
  placeholder,
  required=false,
  min,
  max,
  disabled,
}) => {
  console.log("|res",required);
  
  return (
    <div className="form-group my-2">
      <Label className="from-label" htmlFor={name}>
        {title}
        {required && <Required />}
      </Label>
      <div className="form-control-wrap">
        <input
          placeholder={"Enter mobile number"}
          type="text"
          id={name}
          {...register(name, {
            required: required
              ? {
                  value: true,
                  message: `${title || name} is required`,
                }
              : false,
            validate: (value) => {
    // ✅ Optional field → allow empty
    if (!required && !value) return true;

    // ✅ Required field empty → error
    if (required && !value) return false;

    // ✅ Validate only when value exists
    return (
      validateINMobile(value) ||
      "Enter a valid 10-digit Indian mobile number starting with 6-9"
    );
  },
          })}
           className={`form-control ${errors?.[name] ? "is-invalid" : ""}`}
          value={watch(name)}
          onChange={(e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, "");
            setValue(name, e.target.value);
            trigger(name);
          }}
          onInput={(e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, "");
            e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
          }}
        />
        {errors[name] && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors[name]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyMobile;
